import React from 'react';
import ReactTooltip from 'react-tooltip';
import { defaultTemplate } from 'core/hoc';

const CostBreakdownTooltip = ({ t, idValue, shippingCost, surplusCharge, total, cypressId, displayIcon = false }) => {
	return (
		<React.Fragment>
			<ReactTooltip className="surcharge" id={`$surchargeTooltip-${idValue}`}>
				<div data-cy={cypressId+'-tooltip'} >
				<div data-cy={cypressId+'-shippingCost'} className="item">
					<span>{t('TOOLTIP.SHIPPINGCOST.COST')}</span>
					<span>{` $${shippingCost}`}</span>
				</div>
				<div data-cy={cypressId+'-surplus'} className="item">
					<span>{t('TOOLTIP.SHIPPINGCOST.SURPLUS')}</span>
					<span>{` $${surplusCharge}`}</span>
				</div>
				<div data-cy={cypressId+'-shippingCostTotal'} className="item total">
					<span>{t('TOOLTIP.SHIPPINGCOST.TOTAL')}</span>
					<span>{` $${total}`}</span>
				</div>
				</div>
			</ReactTooltip>
			{displayIcon && (
				<i
					data-for={`$surchargeTooltip-${idValue}`}
					data-tip=""
					className="fa fa-info-circle spc--left--tny flex--grow--1"
					data-cy={cypressId+'-icon'}
				></i>
			)}
		</React.Fragment>
	);
};

export default defaultTemplate(CostBreakdownTooltip);



// WEBPACK FOOTER //
// ./src/common/tooltips/CostBreakdownTooltip.jsx